import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import useProductBrand from '../../hooks/use_product_brand';

const AffiliateBrand = ({ product_brand_id, size = 'sm' }) => {
	const { items: product_brands } = useProductBrand({
		include_product_brands: [product_brand_id],
	});
	const sizes = { lg: 'xl', sm: 'md' };

	const product_brand = product_brands?.length ? product_brands[0] : null;
	if (!product_brand?.fields?.files_logo_url_src) return <></>;

	return (
		<GatsbyImage
			alt={product_brand.product_brand_variant.title}
			className={`thumb-${sizes[size]} rounded-pill bg-white`}
			image={getImage(product_brand.fields.files_logo_url_src)}
		/>
	);
};

AffiliateBrand.propTypes = {
	product_brand_id: PropTypes.string.isRequired,
	size: PropTypes.string,
};

export default AffiliateBrand;
